import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f95be5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitoring__header" }
const _hoisted_2 = { class: "monitoring__header--left-part" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "monitoring__header--datepicker-block" }
const _hoisted_5 = {
  key: 1,
  class: "monitoring__header--checkbox"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Все мои проекты", -1))
const _hoisted_7 = { class: "monitoring__header--total-time-spent" }

import {
  TirCheckbox,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmDatepicker,
  TirPmDropdown,
  TirPmIconView,
  TirPmSearchInput,
} from 'tir-components';
import { ArrowDownTrayIcon } from 'tir-style-system/icons/outline';
import { computed, nextTick, PropType, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { MonitoringPagesEnum } from '../enums';
import GetEmployeesWithAccessToProjectItemModel from '../models/GetEmployeesWithAccessToProjectItemModel';
import { MonitoringHeaderFilterModel } from '../models';


export default /*#__PURE__*/_defineComponent({
  __name: 'monitoring-header',
  props: {
  /**Фильтр */
  filter: { type: Object as PropType<MonitoringHeaderFilterModel> },
  /**Поле поиск */
  search: { type: String },
  /**Поле поиска исполнителей */
  searchFieldPerformers: { type: String },
  /**Исполнители */
  performers: { type: Array as PropType<GetEmployeesWithAccessToProjectItemModel[]> },
  /**Общее затраченное время */
  totalWorkTime: { type: Number },
  /**Дата начала */
  dateStart: { type: Date },
  /**Дата окончания */
  dateEnd: { type: Date },
},
  emits: ["update:search", "update:searchPerformers", "update:selectedDateStart", "update:selectedDateEnd", "selectPerformer", "clearFilter"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();





/**Строка поиска исполнителей*/
const searchBarPerformers = ref();

/**Поиск тикетов */
const innerSearch = computed({
  get: () => props.search,
  set: (value) => emit('update:search', value),
});
/**Выбранный мониторинг */
const selectMonitoringPage = computed(() => router.currentRoute.value.name);
/**Поиск исполнителей */
const searchPerformers = computed({
  get: () => searchBarPerformers.value,
  set: (value) => {
    emit('update:searchPerformers', value);
    searchBarPerformers.value = value;
  },
});
/**Поиск в зависимости от мониторинга */
const searchField = computed({
  get() {
    if (selectMonitoringPage.value === MonitoringPagesEnum.Days) {
      return searchPerformers.value;
    } else if (selectMonitoringPage.value === MonitoringPagesEnum.Tickets) {
      return innerSearch.value;
    }
    return '';
  },
  set(val: string) {
    if (selectMonitoringPage.value === MonitoringPagesEnum.Days) {
      searchPerformers.value = val;
    } else if (selectMonitoringPage.value === MonitoringPagesEnum.Tickets) {
      innerSearch.value = val;
    }
  },
});

/**Отображения label в зависимости от мониторинга */
const label = computed(() => {
  if (selectMonitoringPage.value === MonitoringPagesEnum.Days) {
    return 'Поиск по ФИО';
  } else if (selectMonitoringPage.value === MonitoringPagesEnum.Tickets) {
    return 'Поиск по тикету';
  }
  return '';
});
/**Общее затраченное время */
const totalWorkTime = computed(() => {
  const workTime = props.totalWorkTime.toFixed(2);

  const hours = workTime.split('.')[0].padStart(2, '0');
  const minutes = workTime.split('.')[1].padStart(2, '0');

  return `${hours}ч ${minutes}мин`;
});
/**Выбор начальной даты */
const selectedDateStart = computed({
  get: () => props.dateStart,
  set: (value: Date) => {
    if (value > props.dateEnd) return;
    emit('update:selectedDateStart', value);
  },
});

/**Выбор конечной даты */
const selectedDateEnd = computed({
  get: () => props.dateEnd,
  set: (value: Date) => {
    if (value < props.dateStart) return;
    emit('update:selectedDateEnd', value);
  },
});

/**Отслеживание изменение пути */
watch(
  () => router.currentRoute.value.path,
  () => {
    searchBarPerformers.value = '';
  },
);

/**Изменение состояния чекбокса Все мои проекты */
const changeAllProjectsChecked = (state: boolean) => {
  localStorage.setItem('stateAllMyProjectsChecked', String(state));
  props.filter.AllMyProjectsChecked = state;
};
/**Выбор исполнителя */
const selectPerformer = (performer: GetEmployeesWithAccessToProjectItemModel) => {
  emit('selectPerformer', performer);
  searchBarPerformers.value = `${performer.LastName} ${performer.FirstName} ${performer.MiddleName}`;
};

/**Получить полный список тикетов */
const getFullList = () => {
  searchBarPerformers.value = '';
  emit('clearFilter');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TirPmSearchInput), {
        label: label.value,
        isSmall: "",
        modelValue: __props.filter.Search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.filter.Search) = $event)),
        isWithPopup: false,
        onOnClearSearchInput: getFullList,
        placeholder: ""
      }, null, 8, ["label", "modelValue"]),
      (selectMonitoringPage.value === _unref(MonitoringPagesEnum).Tickets)
        ? (_openBlock(), _createBlock(_unref(TirPmSearchInput), {
            key: 0,
            label: "Исполнитель",
            isSmall: "",
            modelValue: searchPerformers.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchPerformers).value = $event)),
            onOnClearSearchInput: getFullList,
            placeholder: ""
          }, {
            content: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.performers, (performer) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "monitoring__header--dropdown-content",
                  key: performer.UserId,
                  onClick: ($event: any) => (selectPerformer(performer))
                }, [
                  _createVNode(_unref(TirPmIconView), {
                    size: 24,
                    isRounded: "",
                    isBordered: false,
                    colorCode: performer.AvatarColor,
                    imageLoadUrl: performer.Foto
                  }, {
                    mainSlot: _withCtx(() => [
                      _createTextVNode(_toDisplayString(performer.FirstName[0]) + _toDisplayString(performer.LastName[0]), 1)
                    ]),
                    _: 2
                  }, 1032, ["colorCode", "imageLoadUrl"]),
                  _createTextVNode(" " + _toDisplayString(performer.LastName) + " " + _toDisplayString(performer.FirstName) + " " + _toDisplayString(performer.MiddleName), 1)
                ], 8, _hoisted_3))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(TirPmDatepicker), {
          class: "monitoring__header--datepicker",
          input: { label: 'Дата начала', isMicro: true },
          modelValue: selectedDateStart.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDateStart).value = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_unref(TirPmDatepicker), {
          class: "monitoring__header--datepicker",
          input: { label: 'Дата конца', isMicro: true },
          modelValue: selectedDateEnd.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedDateEnd).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Small,
        variant: _unref(TirPmButtonVariantEnum).SecondaryState
      }, {
        leftSlot: _withCtx(() => [
          _createVNode(_unref(ArrowDownTrayIcon))
        ]),
        _: 1
      }, 8, ["size", "variant"]),
      (selectMonitoringPage.value === _unref(MonitoringPagesEnum).Days)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(TirCheckbox), {
              modelValue: __props.filter.AllMyProjectsChecked,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((__props.filter.AllMyProjectsChecked) = $event)),
                changeAllProjectsChecked
              ]
            }, {
              mainSign: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, " Общее время затрачено —  " + _toDisplayString(totalWorkTime.value), 1)
  ]))
}
}

})